import type { ToastProps } from '@models/types';
import MuiSnackbar from '@mui/material/Snackbar';
import styled from 'styled-components';

export const Snackbar = styled(MuiSnackbar)`
    ${(props) => props.theme.breakpointTo.md} {
        left: 16px;
        right: 16px;
    }
`;

export const ToastItem = styled.div<Pick<ToastProps, 'variant'>>`
    display: flex;
    padding: 23px 24px 20px 23px;
    background: ${(props) => props.theme.palette.primaryA7};
    border-radius: 8px;
    min-width: 250px;

    border-left: ${(props) => {
        switch (props.variant) {
            case 'success':
                return `2px solid ${props.theme.palette.secondaryA3}`;
            case 'warning':
                return '2px solid #FABC46';
            case 'error':
                return `2px solid ${props.theme.palette.secondaryA4}`;
        }

        return '';
    }};

    box-shadow: ${(props) => {
        switch (props.variant) {
            case 'success':
                return '0px 10px 20px rgba(12, 65, 162, 0.1)';
            case 'warning':
                return '0px 10px 20px rgba(12, 65, 162, 0.1)';
            case 'error':
                return '0px 10px 20px rgba(12, 65, 162, 0.1)';
        }

        return '';
    }};

    ${(props) => props.theme.breakpointTo.md} {
        padding: 16px 20px 16px 19px;
        max-width: none;
        width: 100%;
    }

    .status-icon-container {
        margin-right: 15px;
    }

    .warning-icon {
        color: ${(props) => props.theme.palette.secondaryA6};
    }

    .success-icon {
        color: ${(props) => props.theme.palette.secondaryA3};
    }

    .content-container {
        display: flex;
        flex-direction: column;
        padding-right: 15px;
        width: calc(100% - 42px);
    }

    .message {
        margin-top: 4px;
    }

    .content {
        margin-top: 4px;
    }

    .header {
        position: relative;
    }

    .close-icon-container {
        position: absolute;
        right: -25px;
        top: -4px;

        svg {
            width: 19.2px;
            height: 19.2px;
        }
    }
`;
